import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./fonts/Pattaya-Regular.ttf";
import "./fonts/YanoneKaffeesatz-VariableFont_wght.ttf";
import "./fonts/Orienta-Regular.ttf";
import "./fonts/Biryani-Regular.ttf";
import App from "./App";

const root = createRoot(document.getElementById("root")); // notice the '!'
root.render(<App />);

// createRoot.render(<App />, document.getElementById("root"));
